export default "__VITE_ASSET__D6K6H3t8__"